define([
	"dojo/_base/declare",
	"csi/def/Action"
], function(declare,Action) {

	return declare(Action, {
		bValidateWithAccess: true
	});
});
